export type OrganisationAdminTab =
  | 'members'
  | 'groups'
  | 'team-assistants'
  | 'handbook'
  | 'connected-apps'
  | 'information-barriers'
  | 'plan'
  | 'purchases';

export const ORGANISATION_ADMIN_TABS: ReadonlyArray<{
  id: OrganisationAdminTab;
  label: string;
}> = [
  { id: 'members', label: 'Members' },
  { id: 'groups', label: 'Groups' },
  { id: 'team-assistants', label: 'Team Secretary' },
  { id: 'handbook', label: 'Handbook' },
  { id: 'connected-apps', label: 'Connected Apps' },
  { id: 'information-barriers', label: 'Information Barriers' },
  { id: 'plan', label: 'Plan & Billing' },
  { id: 'purchases', label: 'Purchases' },
];

export const ORGANISATION_TAB_PARAM = 'tab';
/** Which of the caller's organisations the console shows; survives OAuth round trips. */
export const ORGANISATION_ID_PARAM = 'org';
/** Reopens the invite form after the subscription checkout returns. */
export const ORGANISATION_INVITE_PARAM = 'invite';

/** Older links used these tab ids. */
const LEGACY_TABS: Record<string, OrganisationAdminTab> = {
  card: 'purchases',
  usage: 'plan',
  advanced: 'plan',
};

export function parseOrganisationTab(
  value: string | null,
): OrganisationAdminTab {
  const match = ORGANISATION_ADMIN_TABS.find((t) => t.id === value);
  if (match) return match.id;
  return (value && LEGACY_TABS[value]) || 'members';
}

export function organisationTabPath(tab: OrganisationAdminTab): string {
  return tab === 'members'
    ? '/settings/organisation'
    : `/settings/organisation?${ORGANISATION_TAB_PARAM}=${tab}`;
}
